import { handleLogout } from "../utility/handleLogout";
import { errorNotification } from "../utility/notification";

export const axiosError = async (error) => {
    console.error(error);
    const message = error?.response?.data?.message
    if(error?.response?.status === 401){
        
        errorNotification({
            message : "Session Expired!!!"
        })
        handleLogout()


    } else if(message){
    errorNotification({
        message
    })
}

throw error
}
